<!-- Section 13 -->
<section id="section-14" class="section-divider-ipg">
  <h3 class="heading-2-ipg">Section Thirteen</h3>
  <h3 class="heading-3-ipg">Epilogue</h3>

  <p class="paragraph-1-ipg">This simple introduction to Pāli grammar and pronunciation was prepared to present a quick reference guide while studying  the suttas in the Pāli program, <a href="https://learning.pariyatti.org/course/view.php?id=2" target="_blank">Exploring the Path</a> at the <a href="learning.pariyatti.org" target="_blank">Pariyatti Learning Center</a>.</p>  

  <p class="paragraph-1-ipg">A simple and basic understanding of grammar is helpful for the comprehension of the texts, but the main emphasis should remain with reading Pāli in the context, where most grammatical patterns will become clear. In the same way as pronunciation of letters of the alphabet may only prove useful in order to learn the correct movement of the organs of pronunciation, the rules of <italic-w-ipg>sandhi</italic-w-ipg> will only become obvious in the context of syllable and word combinations and the principles of grammar will become evident in the context of sentences.</p> 
  
  <p class="paragraph-1-ipg">May this introduction encourage more people to learn the Pāli language which provides us with irreplaceable values for our own lives and the lives of so many others. May reading and working with the suttas as collected in <a href="https://learning.pariyatti.org/course/view.php?id=2" target="_blank"><em>Exploring the Sacred, Ancient Path in the Original Words of the Buddha</em></a> support a better understanding of one’s own practice of <span class="italic-w-ipg">paṭipatti</span>. May more and more people be inspired to walk the path of Dhamma. May the benevolent wish of my respected teacher be fulfilled!</p>
  
  
  <div id="hindi-doha">
  <pre>
    Jāge jāge dharama kī vāṇī
    Maṅgala mūla mahā kalyānī
    Maṅgala mūla mahā kalyānī
    Jāge jāge dharama kī vāṇī
  
    May the words of the Dhamma arise,
    Those roots of great happiness and well-being,
    Those roots of great happiness and well-being,
    May the words of the Dhamma arise!
  </pre>
  
  <address class="credit">&mdash;Hindi dohas by S. N. Goenka during his 10-day courses</address>  
</div>
  
  <!-- No footnotes for Section 13 -->
</section>
<!-- /Section 13 -->


<style>
  div#hindi-doha {
    width: 100%;
    margin: 20px 0 10px 0;
    text-align: center;
  }

  pre {
    font-size: 1.1rem;
  }

  address {
    font-size: .9rem;
    margin: 0 0 10px 0;
  }
</style>